import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { EventTypeEnum } from 'src/app/shared/enum/event-type.enum';
import { EventActionService } from 'src/app/shared/services/eventAction.service';
import { environment } from 'src/environments/environment';
import { MatSpinnerOverlayService } from './../../../core/services/mat-spinner-overlay.service';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  
  currentRoute: string;
  appName: string;
  displaySpinner: boolean;

  constructor(private matSpinnerOverlayService: MatSpinnerOverlayService, private eventActionService : EventActionService, private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.currentRoute = event['url'];
    })
  }

  ngOnInit(): void {
    this.appName = environment.app_name;
    this.displaySpinner = false;
    this.matSpinnerOverlayService.getDisplay().subscribe((value) => {
      this.displaySpinner = value;
    });
  }

  onRefreshEvent(event): void {
    this.eventActionService.sendCustomEvent(this.currentRoute.substring(this.currentRoute.lastIndexOf("/") + 1) as EventTypeEnum);
  }
}
